import { useEffect } from 'react';

import { useRouter } from 'next/router';

import RestrictedPageLoader from '../../components/loader/restrictedpage';
import ReferralsMechanism from '../../containers/referralsGeneralMechanism/referrals-mechanism';
import ReferralsOther from '../../containers/referralsGeneralMechanism/referrals-mechanism-others';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import { referralEnabledMarkets } from '../../links.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/globals/globals.scss';
import '../../styles/referrals-mechanism.scss';

const Referrals = () => {
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const router = useRouter();
  const country = codes.length === 2 ? codes[0] : 'sg';

  useEffect(() => {
    if (!referralEnabledMarkets.includes(country)) {
      router.replace(`/${i18n.activeLocale}/`);
    }
  }, [country]);

  return (
    <div className="wrapper referral-page-whole">
      <main>
        {referralEnabledMarkets.includes(country) ? <ReferralsMechanism /> : <RestrictedPageLoader />}
      </main>
    </div>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.REFERRALS_MECHANISM;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default Referrals;
